export default __webpack_public_path__ + "media/images/iui/listArrowSel-c0ed4ffeae0120100c24d2419c002b97.png";